import type { ListerSessionSummary } from "../../../lib/api";
import { hashFor } from "../../../lib/routes";
import StatusPill from "../../../components/StatusPill";

export default function RecentSessions({ sessions }: { sessions: ListerSessionSummary[] }) {
  if (sessions.length === 0) return null;
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-xs">
        <span className="text-zinc-500">recent</span>
        <a href={hashFor.history()} className="text-zinc-400 underline">full history</a>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {sessions.map((s) => (
          <a key={s.id} href={hashFor.review(s.id)} className="shrink-0 bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-xs">
            <div className="text-zinc-300 max-w-[12rem] truncate">{s.title ?? s.gtin}</div>
            <StatusPill status={s.status} />
          </a>
        ))}
      </div>
    </div>
  );
}
